module.exports = __webpack_public_path__ + "img/stmlogo.a9370522.png";